<template>
  <div class="document-translation-section">
    <header>
      <p class="title-header">
        {{$t('fileManage.docTranslation')}}
      </p>
      <div class="header-operation">
        <div class="header-operation-l">
          <el-select @change="changeSource" v-model="seletionInfo.sourceLang" class="source-select"
                     :placeholder="$t('intelligentTranslation.automaticDetection')" size="small"
                     clearable>
            <el-option v-for="item in sourceOption" :key="item.sourceLang"
                       :label="$i18n.locale==='zh'?item.sourceLangName:getEnlang(item.sourceLang)"
                       :value="item.sourceLang">
            </el-option>
          </el-select>
          <div class="icon-lang"></div>
          <el-select :no-data-text="$t('newProjectV2.firstSelSourceLangTip')" size="small"
                     v-model="seletionInfo.targetLang"
                     :placeholder="$t('jobManagementV2.selectText')" @change="changeTarget"
                     clearable>
            <el-option v-for="item in targetOption" :key="item.targetLang"
                       :label="$i18n.locale==='zh'?item.targetLangName:getEnlang(item.targetLang)"
                       :value="item.targetLang">
            </el-option>
          </el-select>
          <el-select v-model="seletionInfo.domainCode" class="field" size="small"
                     :placeholder="$t('memoryBankV2.pleaseDomain')" @change="changDomainList"
                     clearable>
            <el-option v-for="(item,index) in fieldOption" :key="index"
                       :label="$i18n.locale==='zh'?item.transDomainName:item.transDomainCode"
                       :value="item.transDomainCode"></el-option>
          </el-select>
        </div>
        <div class="header-operation-r">
          <el-button size="small" type="primary" @click="handlerTranslate">
            {{$t('intelligentTranslation.TranslationSetting')}}</el-button>
        </div>
      </div>
    </header>
    <main>
      <div class="upload-box">
        <el-upload class="upload" action :http-request="uploadSectionFile" multiple drag :limit="$supportFileSuffixes().limit"
                   :on-exceed="handleExceed" :file-list="fileList" :before-upload="beforeUploadFile"
                   :on-progress="uploadFileProcess" :on-change="uploadChange"
                   :show-file-list="false" :accept="accept">
          <el-table v-if="fileList.length >0" class="tabBox" border :data="fileList">
            <el-table-column type="index" :label="$t('projectV2.index')" width="60" align="center">
            </el-table-column>
            <el-table-column prop="name" :label="$t('jobManagementV2.fileName')" align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="size" :label="$t('jobManagementV2.fileSize')" align="center"
                             :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <p>{{formateSize(row.size)}}</p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('project.status')" align="center" class-name="progress">
              <template slot-scope="{row}">
                <el-progress :stroke-width="8" :status="row.exception"
                             :percentage="isNaN(row.percentage) ? 100 : row.percentage">
                </el-progress>
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.operation')" min-width="40" align="center"
                             class-name="operation">
              <template slot-scope="{row,$index}">
                <el-tooltip class="item" effect="dark" :content="$t('common.del')"
                            placement="bottom">
                  <i class="icon-delete" @click.stop="handleDelete($index, row)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <div class="uploadBox" :class="fileList.length>0?'filelist':'filenone'">
            <div class="upload-img"></div>
            <div slot="tip" class="el-upload__tip">
              {{$t('intelligentTranslation.Clickordragthefileheretoupload')}}
            </div>
          </div>
        </el-upload>
        <div class="file-info">
          <div class="file-info-l">
            <p>{{$t('intelligentTranslation.Numberofdocuments')}}：<em>{{fileList.length}}</em></p>
            <p>{{$t('intelligentTranslation.Totalfilesize')}}：<em>{{formateSizeAll(fileList)}}</em>
            </p>
          </div>
          <div class="file-info-r">
            <el-button size="small" @click="handleclearAll">
              {{$t('intelligentTranslation.ClearAll')}}</el-button>
          </div>
        </div>
      </div>
    </main>
    <footer>
      <div class="footer-tips">
        <div class="footer-tips-l">
          <p class="tips-size">
            {{$t('intelligentTranslation.Singlefilesize')}}：<em>{{$supportFileSuffixes().maxSize}}MB</em>{{$t('intelligentTranslation.Belowupto')}}<em>{{$supportFileSuffixes().limit}}</em>{{$t('intelligentTranslation.Files')}}
          </p>
          <p>
            {{$t('newProjectV2.suppFormat')}}：<em>doc、docx、xls、xlsx、ppt、pptx、txt、pdf、xlf、eml、html、htm、jpg、png、bmp、tiff、dwg、dxf</em>
          </p>
        </div>
        <div class="footer-tips-r">
          <el-button size="small" class="translationHistory" @click="handlerTranslationHistory">
            {{$t('fileManage.transHistory')}}
          </el-button>
          <el-button size="small" type="primary" class="translation" @click="handlerTranslation">
            {{$t('project.translation')}}
          </el-button>
        </div>
      </div>
    </footer>
    <translationSettings-dialog :translateVisible="translateVisible"
                                @handlerClose="translateVisible=false"
                                @handlerdetermine="determinetranslationSettings"
                                :langInfo="langInfo"
                                @determinetranslationCorpus="determinetranslationCorpus">
    </translationSettings-dialog>
  </div>
</template>
<script>
import {
  getFileLang,
  getUploadSign,
  queryLangList,
  queryTransDomain,
  saveProject,
} from '@/services/newProjectApi';
import axios from "axios";
import translationSettingsDialog from "../../components/translationSettingsDialog";
import moment from "moment"
export default {
  name: 'DocumentTranslation',
  data() {
    return {
      seletionInfo: {
        sourceLang: "",
        targetLang: "",
        sourceLeft: "",
        sourceRight: "",
        domainCode: "",
        langDesc: "",
        transDomainName: ""
      },
      sourceOption: [],
      targetOption: [],
      fieldOption: [],
      fileList: [],
      accept: ".doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.pdf,.xlf,.eml,.html,.htm,.jpg,.png,.bmp,.tiff,.dwg,.dxf",
      uploadSignInfo: {},
      translateVisible: false,
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
      memorymounteId: [],
      termmounteId: [],
      threshold: 0,
      filePaht: "",
      langInfo: {},
      dataInfo: {
        isUseMemory: null,
        isTermIntervene: null
      },
      clearFlag: false,
    }
  },
  components: { translationSettingsDialog },
  mounted() {
    this.getSourceLangList()
  },
  methods: {
    handlerTranslationHistory() {
      this.$router.push({ name: "translationHistory" })
    },
    handleclearAll() {
      this.fileList = []
    },
    determinetranslationCorpus(mountInfo) {
      this.memorymounteId = mountInfo.memoryIdList
      this.termmounteId = mountInfo.termIdList;
      this.threshold = mountInfo.threshold
      this.translateVisible = true;
    },
    formateSizeAll(fileList) {
      if (fileList.length === 0) {
        return 0;
      }
      let sizeArr = fileList.map(item => item.size);
      const sizeAll = sizeArr.reduce((pre, cut) => {
        return pre + cut
      })
      let kbsize = (sizeAll / 1024).toFixed(2)
      if (kbsize > 1024) {
        return (kbsize / 1024).toFixed(2) + "M"
      } else {
        return kbsize + "kb"
      }
    },
    handlerTranslate() {
      this.langInfo = {
        sourceLang: this.seletionInfo.sourceLang,
        targetLang: this.seletionInfo.targetLang,
      }
      if (!(this.seletionInfo.sourceLang && this.seletionInfo.targetLang)) {
        this.$message.closeAll();
        this.$message.warning(this.$t('intelligentTranslation.Pleaseselectalanguagepair'))
        return;
      }
      this.translateVisible = true
    },
    determinetranslationSettings(dataInfo) {
      this.dataInfo.isUseMemory = dataInfo.switchone;
      this.dataInfo.isTermIntervene = dataInfo.switchtow;
      this.translateVisible = false
    },
    //翻译
    async handlerTranslation() {

      if (this.fileList.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.uploadFileTip'));
        return
      }
      if (!(this.seletionInfo.sourceLang && this.seletionInfo.targetLang)) {
        this.$message.closeAll();
        this.$message.warning(this.$t('intelligentTranslation.Pleaseselectalanguagepair'))
        return;
      } else if (!(this.seletionInfo.domainCode)) {
        this.$message.closeAll();
        this.$message.warning(this.$t('common.domainTip'))
        return;
      }
      let transFileList = []
      this.fileList.forEach(item => {
        let obj = {
          filePath: item.path,
          fileSuffix: item.uppercaseSuffix,
          name: item.name,
          transModel: 2
        }
        transFileList.push(obj)
      })
      let params = {
        domain: this.seletionInfo.transDomainName,
        name: this.fileList[0].name,
        memoryList: this.memorymounteId,
        termList: this.termmounteId,
        domainCode: this.seletionInfo.domainCode,
        sourceLang: this.seletionInfo.sourceLang,
        targetLang: this.seletionInfo.targetLang,
        transFileList: transFileList,
        langDesc: this.seletionInfo.langDesc,
        projectProcessType: 1,
        deliveryTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        ifRepeatLock: 0,
        transModel: 2,
        sourceType: 0,
        isTermIntervene: this.dataInfo.isTermIntervene ? 1 : 0,
        isPreMt: 1,
        memorySimilarPercent: this.threshold,
        isOpenQa: 0,
        qaList: [],
        documentSettingList: [],
        mtSupplierId: 1,
        isAutoCommit: 1,
        isUseMemory: this.dataInfo.isUseMemory ? 1 : 0,
        remark: '',
        mtSearchId: 1,
        companyCode: this.companyCode,
      }
      const { result, success } = await saveProject(params);
      if (success) {
        this.$message.success(this.$t('newProjectV2.newSuccess'));
        this.fileList = [];
        // location.reload();
        this.$router.push(
          {
            name: "translation",
            query: {
              key: this.$Base64.encode(JSON.stringify({
                langDesc: this.seletionInfo.langDesc,
                sourceLang: this.seletionInfo.sourceLang,
                targetLang: this.seletionInfo.targetLang,
                domainCode: this.seletionInfo.domainCode,
                fileLength: this.fileList.length,
                project_id: result.id,
                transDomainName: this.seletionInfo.transDomainName
              }))
            }
          }
        )
      }
    },
    async getTargetOption(value) {
      this.seletionInfo.targetLang = "";
      let { result, success } = await queryLangList({
        type: 2,
        sourceLang: value
      });
      if (!success) { return; }
      this.targetOption = result.filter(item => {
        return item.status === 1
      });
      if (this.targetOption.length === 0) {
        this.$message.warning(this.$t('newProjectV2.langNotSupport'));
        this.seletionInfo.sourceLang = '';
        return;
      }
      // 目标语言默认选择第一项
      if(!this.seletionInfo.targetLang){
        this.seletionInfo.targetLang = this.targetOption[0].targetLang;
      }
      this.getTarget(this.seletionInfo.sourceLang, this.seletionInfo.targetLang)
      this.getDomainList(this.seletionInfo.sourceLang, this.seletionInfo.targetLang);
    },
    async changeSource(value) {
      this.seletionInfo.targetLang = "";

      this.targetOption = []
      if (!value) {
        return
      }
      // console.log(value
      let { result, success } = await queryLangList({
        type: 2,
        sourceLang: value
      });
      if (!success) { return; }
      this.targetOption = result.filter(item => {
        return item.status === 1
      });

      if (this.targetOption.length === 0) {
        this.$message.warning(this.$t('newProjectV2.langNotSupport'));
        this.seletionInfo.sourceLang = '';
        return;
      }
      this.seletionInfo.sourceLeft = this.sourceOption.find(item => item.sourceLang === value).sourceLangName;
    },
    getTarget(value, value1) {
      this.seletionInfo.sourceLeft = this.sourceOption.find(item => item.sourceLang === value).sourceLangName;
      this.seletionInfo.sourceRight = this.targetOption.find(item => item.targetLang === value1).targetLangName;
      this.seletionInfo.langDesc = `${this.seletionInfo.sourceLeft}>${this.seletionInfo.sourceRight}`
    },
    changeTarget(value) {
      if (value) {
        this.seletionInfo.sourceRight = this.targetOption.find(item => item.targetLang === value).targetLangName;
        this.seletionInfo.langDesc = `${this.seletionInfo.sourceLeft}>${this.seletionInfo.sourceRight}`
        this.getDomainList(this.seletionInfo.sourceLang, this.seletionInfo.targetLang);
      }
    },
    //获取源语言
    async getSourceLangList() {
      let { result, success } = await queryLangList({
        type: 1
      });
      if (!success) {
        return;
      }
      this.sourceOption = result;
    },
    async getDomainList(sourceLangCode, targetLangCode) {
      if (!(sourceLangCode, targetLangCode)) {
        return
      }
      let self = this;
      let { result, success } = await queryTransDomain({
        sourceLangCode,
        targetLangCode,
        isProjectQuery:2
      })
      if (!success) { return; }
      self.fieldOption = result;
      // 领域默认选择第一项
      self.seletionInfo.domainCode = result[0].transDomainCode;
      self.seletionInfo.transDomainName = result[0].transDomainName
    },
    changDomainList(value) {
      let field = this.fieldOption.filter(item => item.transDomainCode === value);
      this.seletionInfo.transDomainName = field[0].transDomainName
    },
    formateSize(size) {
      let kbsize = (size / 1024).toFixed(2)
      if (kbsize > 1024) {
        return size = (kbsize / 1024).toFixed(2) + "M"
      } else {
        return size = kbsize + "kb"
      }
    },
    async  uploadSectionFile(param) {
      await this.getUploadSign()
      const file = param.file
      const type = file.name.split('.')[file.name.split('.').length - 1]
      const { keyPrefix, sign, token, ts } = this.uploadSignInfo
      const formDataParams = {
        key: `${keyPrefix}.${type}`,
        file: param.file,
        sign,
        token,
        ts
      }
      const formData = new FormData()
      Object.keys(formDataParams).forEach(key => {
        formData.append(key, formDataParams[key])
      })
      this.getFileHost(param, formData)
    },
    // 获取上传签名
    async getUploadSign() {
      const { success, result } = await getUploadSign()
      if (!success) return
      this.uploadSignInfo = result
    },
    getFileHost(param, formData) {
      const self = this
      let config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios.post(self.uploadSignInfo.host, formData, config)
        .then(({ data, status }) => {
          if (status !== 200 || !data.success) return
          const { result } = data
          self.getFileContent(result.fileName, param);
          self.fileList.forEach(item => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              this.$set(item, "path", result.fileName)
            }
          });
          // 检测语言
          if (['png', 'jpg', 'tiff', 'bmp'].includes(result.fileName.split('.')[result.fileName.split('.').length - 1])) {
            return;
          } else {
            self.getLong(result.fileName, param);
          }
        })
    },
    // 检测语言方法
    getLong(path, param) {
      let self = this;
      getFileLang({
        path
      }).then(({ result, success }) => {
        if (!success) {
          return;
        }
        // 添加源语言字段
        this.fileList.forEach(item => {
          if (item.uid === param.file.uid) {
            item.source = result.sourceLangName || "";
          }
        });
        // 如果文件源语言检测为空，则跳过
        if (!result.sourceLang) {
          return;
        }
        if (self.seletionInfo.sourceLang) {
          return;
        }
        self.seletionInfo.sourceLang = result.sourceLang;
        self.getTargetOption(self.seletionInfo.sourceLang)

      });
    },
    async getFileContent(path, param) {
      const uid = param.file.uid
      const { success, result } = await this.catReq1Service(this.fileUrl, {
        fileUrlList: [path]
      })
      if (!success) return
      const { status, reason: message } = result
      if (!status) {
        this.$message.closeAll();
        this.$message({
          message,
          type: "error"
        });
      }
      this.fileList.forEach(item => {
        if (item.uid === uid) {
          if (!status) {
            item.percentage = -1
          }
        }
      })
      this.fileList = this.fileList.filter(item => item.percentage !== -1)
    },
    handleDelete(index, row) {
      this.fileList.splice(index, 1);
    },
    beforeUploadFile(file) {
      const type = file.name.split('.')[file.name.split('.').length - 1]
      const isLt20M = file.size / 1024 / 1024 < this.$supportFileSuffixes().maxSize;
      if (!this.accept.includes(type)) {
        this.$message.closeAll()
        this.$message({
          message: this.$t('newProjectV2.onlySupportFormate', [this.accept]),
          type: "warning"
        })
        return false
      }
      this.fileList.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.$message.warning(this.$t('newProjectV2.uploadFileRepeat'));
          this.fileList.pop();
          file.obp = true;
          return false;
        }
      });
      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: this.$t("termBankV2.uploadFileContentEmpty"),
          type: "warning"
        });
        return false;
      }
      if (!isLt20M) {
        this.$message.closeAll();
        this.$message({
          message: this.$t("termBankV2.uploadFileSize", [this.$supportFileSuffixes().maxSize]),
          type: "warning"
        });
        file.obp = false;
        return false;
      }
      return true
    },

    uploadChange(event, file) {
      this.fileList = file
      this.fileList.forEach(item => {
        const uppercaseSuffix = item.name.split('.')[item.name.split('.').length - 1];
        this.$set(item, 'uppercaseSuffix', uppercaseSuffix)
      })
    },
    uploadFileProcess(event, file, fileList) {
      fileList.forEach(item => {
        if (parseInt(item.percentage) !== 100) {
          item.progressPercent = Math.abs(item.percentage.toFixed(0));
        }
      })
    },
    handleExceed() {
      this.$message({
        message: this.$t('intelligentTranslation.Uptotenfiles'),
        type: "warning"
      })
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/index.less";
</style>